import { Routes } from '@angular/router';

import { DashboardComponent } from './components/dashboard.component';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
];
